import React from 'react';
import { Search, Filter, MapPin, Calendar, TrendingUp } from 'lucide-react';
export function Sites() {
  const sites = [{
    id: 'CH-001',
    name: 'Pont Rivière-Nord',
    city: 'Montréal',
    status: 'En cours',
    progress: 65,
    manager: 'M. Dubois',
    budget: '2.5M$'
  }, {
    id: 'CH-014',
    name: 'Égout Laval',
    city: 'Laval',
    status: 'À risque',
    progress: 42,
    manager: 'M. Roy',
    budget: '1.8M$'
  }, {
    id: 'CH-022',
    name: 'Réfection Rue King',
    city: 'Sherbrooke',
    status: 'À risque',
    progress: 28,
    manager: 'Mme Gagnon',
    budget: '980K$'
  }, {
    id: 'CH-035',
    name: 'Viaduc Highway 40',
    city: 'Montréal',
    status: 'En cours',
    progress: 81,
    manager: 'M. Leblanc',
    budget: '3.2M$'
  }];
  return <div className="space-y-6" data-id="element-397">
      <div className="flex items-center justify-between" data-id="element-398">
        <h1 className="text-3xl font-bold text-gray-900" data-id="element-399">Chantiers</h1>
        <button className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors font-medium" data-id="element-400">
          + Nouveau chantier
        </button>
      </div>
      {/* Filters */}
      <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-401">
        <div className="flex items-center space-x-4" data-id="element-402">
          <div className="flex-1 relative" data-id="element-403">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} data-id="element-404" />
            <input type="text" placeholder="Rechercher un chantier..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500" data-id="element-405" />
          </div>
          <button className="flex items-center space-x-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-406">
            <Filter size={20} data-id="element-407" />
            <span data-id="element-408">Filtres</span>
          </button>
        </div>
      </div>
      {/* Sites Table */}
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-409">
        <table className="w-full" data-id="element-410">
          <thead className="bg-gray-50 border-b border-gray-200" data-id="element-411">
            <tr data-id="element-412">
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-413">
                Chantier
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-414">
                Localisation
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-415">
                Statut
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-416">
                Avancement
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-417">
                Responsable
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-418">
                Budget
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-419">
            {sites.map(site => <tr key={site.id} className="hover:bg-gray-50 cursor-pointer transition-colors" data-id="element-420">
                <td className="px-6 py-4" data-id="element-421">
                  <div data-id="element-422">
                    <p className="font-semibold text-gray-900" data-id="element-423">{site.name}</p>
                    <p className="text-sm text-gray-600" data-id="element-424">{site.id}</p>
                  </div>
                </td>
                <td className="px-6 py-4" data-id="element-425">
                  <div className="flex items-center text-gray-700" data-id="element-426">
                    <MapPin size={16} className="mr-1 text-gray-400" data-id="element-427" />
                    {site.city}
                  </div>
                </td>
                <td className="px-6 py-4" data-id="element-428">
                  <span className={`inline-flex px-2 py-1 text-xs font-medium rounded ${site.status === 'À risque' ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'}`} data-id="element-429">
                    {site.status}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-430">
                  <div className="flex items-center space-x-2" data-id="element-431">
                    <div className="flex-1 bg-gray-200 rounded-full h-2 max-w-[100px]" data-id="element-432">
                      <div className="bg-blue-600 h-2 rounded-full" style={{
                    width: `${site.progress}%`
                  }} data-id="element-433" />
                    </div>
                    <span className="text-sm text-gray-700 font-medium" data-id="element-434">
                      {site.progress}%
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 text-gray-700" data-id="element-435">{site.manager}</td>
                <td className="px-6 py-4 font-medium text-gray-900" data-id="element-436">
                  {site.budget}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}